import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUI } from '../../DataStore/UIContext';
import { useClearState } from '../../DataStore/useClearState';
import ajaxUser from '../../util/remote/ajaxUser';
import { useAuth } from '../../DataStore/AuthContext';

const Topbar = () => {
  const [loading, setLoading] = useState(false);
  const { toggleSidebar } = useUI();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const clearAllState = useClearState();
  const navigate = useNavigate();
  const {user, getMyProfile} = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    getMyProfile();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setShowDropdown(!showDropdown);
  };

   const handleLogout = ()=>{
        // Clear all states and remove token
        clearAllState();
        localStorage.removeItem('ofc');
        navigate('/login');
        window.location.reload();
    }

     const hanldeProfileExit = async()=>{
        if(loading){
            return;
        }
        setLoading(true);
        const server_response = await ajaxUser.exitProfile();
        setLoading(false);
        if(server_response.status === "OK"){
            navigate('/switch');
            window.location.reload();
        }
    }

  return (
    <div className="main-header side-header sticky">
      <div className="container-fluid">
        <div className="main-header-left">
          <Link className="main-logo d-lg-none" to="/">
            <img src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"} className="header-brand-img desktop-logo" alt="logo" />
            <img src={process.env.PUBLIC_URL + "/assets/img/brand/icon.png"} className="header-brand-img icon-logo" alt="icon" />
            <img src={process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"} className="header-brand-img desktop-logo theme-logo" alt="logo-light" />
            <img src={process.env.PUBLIC_URL + "/assets/img/brand/icon-light.png"} className="header-brand-img icon-logo theme-logo" alt="icon-light" />

          </Link>
          <span className="main-header-menu-icon link" id="mainSidebarToggle" onClick={toggleSidebar}>
            <span></span>
          </span>
        </div>
        <div className="main-header-right">
          <div className="dropdown d-md-flex">
            <Link className="nav-link icon full-screen-link" to="#">
              <i className="fe fe-maximize fullscreen-button"></i>
            </Link>
          </div>
          <div className="dropdown main-profile-menu" ref={dropdownRef}>
            <span 
              className="main-img-user avatar-initials text-white link" 
              onClick={toggleDropdown}
              aria-expanded={showDropdown}
              aria-haspopup="true"
            >
              {user?.initials}
            </span>
            <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>

              <div className="header-navheading">
                    <h6 className="main-notification-title">{user?.full_name}</h6>
                    <p className="main-notification-text">{user?.role?.role_name}</p>
                </div>
              <Link className="dropdown-item" to="#" onClick={hanldeProfileExit}>
                <i className="fe fe-user"></i> Switch Profile
              </Link>
              <Link className="dropdown-item" to="/settings">
                <i className="fe fe-settings"></i> Settings
              </Link>
              <Link className="dropdown-item" to="#" onClick={handleLogout}>
                <i className="fe fe-power"></i> Sign Out
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;